import React from 'react';
import { RadioGroup, Radio, FormControlLabel } from '@material-ui/core';

import { SettingHeader, SettingsContainer, TitleContainer } from '../components/BranchComponents';
import { MOBILE_PAYMENT_METHOD_CODE } from '../constants';

const PaymentMethodSettings = ({ pharmacy, organisation, onChange, paymentMethods }) => {
  const { paymentMethod: currentPaymentMethod } = pharmacy;
  const { payment } = organisation || {};
  const { stripe_connect_id: stripeId } = payment || {};

  const disablePaymentChange = stripeId && currentPaymentMethod && currentPaymentMethod.code === 4;

  const paymentMethodChangeHandler = e => {
    const { value: code } = e?.target || {};

    const { _id, ...paymentMethod } = paymentMethods.find(item => item.code === +code);

    onChange('paymentMethod', paymentMethod);
  };

  return (
    <SettingsContainer>
      <SettingHeader>
        <TitleContainer>Payment Methods</TitleContainer>
      </SettingHeader>
      <RadioGroup
        aria-label="payment"
        name="paymentMethod"
        value={String(currentPaymentMethod?.code)}
        onChange={paymentMethodChangeHandler}
      >
        {paymentMethods && paymentMethods.map(({ name, code }) => (
          <FormControlLabel
            value={String(code)}
            control={<Radio />}
            label={name}
            key={code}
            disabled={disablePaymentChange || (code === MOBILE_PAYMENT_METHOD_CODE && !stripeId)}
          />
        ))}
      </RadioGroup>
    </SettingsContainer>
  );
};

export default PaymentMethodSettings;
